import utils from "../utils"

const Path = (props) => {
 
    let {routes, awbInfo} = props
    routes = routes ? routes : []
    
    const routesHTML = routes.map((route) => {

    var routeHTML = [];
    var routeHTML2 = [];
    
    for (var x in route.status) {

      let time = <span> No info received <br/> </span>
      let pieces_ = ""
      let weight_ = ""

      let statusHTML = ""
      let props_class = "" 
      let icon = utils.ICONS[x]

      if(Object.keys(route.status).length === 3)
        props_class = "card columns three";
      else
        props_class = "card columns six";

      let props_color = "grey" ;

      if(route.status[x]){

        let {pieces , weight, event_date} = route.status[x]

        pieces = pieces ? parseInt(pieces) : pieces

        time =   utils.convertDate(event_date, true); 
        time = <span>{time}*</span>
        pieces_ = `${pieces} ${pieces > 1 ? "pcs" : "pc"}`
        weight_ = `${!weight || weight === '0.0' ? "" : weight + " kg"}`;

        if(pieces < parseInt(awbInfo.pieces) )
          props_color = "#dc6823";
        else
          props_color = "green";

      }
              
      statusHTML = ( 
        <span> 
          <div  className ="card status inner" style={{backgroundColor : props_color }} > 
            {icon} <br />{x.toUpperCase()}
          </div> 
          <br/>
          <span className="status inner" style={{marginBottom : "0.5rem"}}>{time}</span>
          <span className="status inner"><br/>{pieces_}{weight_}</span>
        </span>
      )
              

      routeHTML.push(
        <div className={props_class } style={{  color : "black", textAlign : "center", lineHeight : 1, fontStyle : "italic"}}> 
          {statusHTML} 
        </div> 
      )

      routeHTML.push(<div className=""> </div>)
    }

    routeHTML2.push(<div>{routeHTML}</div>)

    let props_class_2 = "card  secondary columns four";
    
    if(Object.keys(route.status).length === 3)
      	props_class_2 = "card secondary columns seven ";
    
    return <div className={props_class_2}>
        <h3 style={{textAlign : "center"}}>{route.name}</h3>
        {routeHTML2} 
    </div>
  });
  
  var routesHTML2 = [];
  let section = [];
  let nextroute = [];
  let nextroute2 = [];

  for(let i = 0; i < routesHTML.length; i = i + 3){
    nextroute = <div className="columns four"> </div>
    nextroute2 = <div className="columns four"> </div>
    
    if(i + 1 < routesHTML.length)
      nextroute = routesHTML[i+1]

    if(i + 2 < routesHTML.length)
      nextroute2 = routesHTML[i+2]
      
    section = <section key={"route" + i} > {routesHTML[i]} {nextroute}  {nextroute2} </section>;
  
    routesHTML2.push(section)

  }  

  return (<div id="table_routes">{routesHTML2}</div>)
};

export default Path;